// Styles
import '../scss/main.scss';

//Services
import '~/services/index.js';

// Images
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

// Utils
import '~/utils/track-ad-source.js';
import '~/utils/prolong-cookies.js';
import '~/utils/first-interaction-event.js';

// Scripts
import DM from 'DM';
import Vue from 'vue';
import { EventBusPlugin } from './plugins/event-bus';
import { AnalyticsPlugin } from './plugins/analytics';

window.Vue = Vue;
window.Vue.config.productionTip = false;
window.Vue.config.devtools = process.env.NODE_ENV === 'production' ? false : true;
window.Vue.config.performance = process.env.NODE_ENV === 'production' ? false : true;

// Vue plugins
Vue.use(AnalyticsPlugin);
Vue.use(EventBusPlugin);

// Modules
import '~/modules/error-logger';
import '~/modules/external-scripts';
import '~/modules/redirect-fast';
import '~/modules/element-views-tracker';
import '~/modules/drawer';
import '~/modules/portal';
import '~/modules/menu';
import '~/modules/mega-menu';
import '~/modules/mega-menu-hydration';
import '~/modules/header-search';
import '~/modules/header-user';
import '~/modules/coupon-button';
import '~/modules/likes-counter';
import '~/modules/likes';
import '~/modules/account-forms';
import '~/modules/message';
import '~/modules/return-top';
import '~/modules/tracking';
import '~/modules/form-confirm';
import '~/modules/toggle';
import '~/modules/omnibus';
import '~/modules/ga-tracking';
import '~/modules/account';
import '~/modules/lightbox';
import '~/modules/page-head-message';
import '~/modules/fake-link.js';
import '~/modules/recaptcha.js';
import '~/modules/accordion.js';
import '~/modules/newsletter-form.js';
import '~/modules/newsletter-modal.js';
import '~/modules/seo-indexer.js';
import '~/modules/redirect-message';
import '~/modules/url-switch.js';
import '~/modules/tiktok-video-loader.js';

if (!window.fetch || (window.Element && !Element.prototype.closest)) {
    import(/* webpackChunkName: "polyfill" */ `~/entries/polyfill`)
}

// Entry
const entries = {
    home: () => import(/* webpackChunkName: "home" */ `~/entries/home`),
    products: () => import(/* webpackChunkName: "products" */ `~/entries/products`),
    productdetails: () => import(/* webpackChunkName: "productdetails" */ `~/entries/product-details`),
    trends: () => import(/* webpackChunkName: "trends" */ `~/entries/trends`),
    landingpages: () => import(/* webpackChunkName: "landing-pages" */ `~/entries/landing-pages`),
    others: () => import(/* webpackChunkName: "others" */ `~/entries/others`)
};

entries[DM.Entry] ? entries[DM.Entry]() : entries.others();
